











































































import Component from "vue-class-component";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import { HeaderWidthItem } from "@/types";
import { Emit, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class BillingList extends Vue {
  @Prop({ default: "" }) private yearmonth!: string;
  @Prop({ default: "対象年月" }) private label!: string;
  @Prop({ default: "" }) private hint!: string;

  @Prop({ default: () => [] }) private tableItems!: object[];

  @Emit("update:yearmonth") private updateYearmonth(value: string) {
    return value;
  }

  @Emit() private search() {
    return;
  }

  @Emit() private download() {
    return;
  }

  @Watch("tableItems") watchTableItems() {
    this.onresize();
  }

  //=================================================================
  // 請求一覧（詳細）
  //=================================================================
  //項目
  private headerItems: HeaderWidthItem[] = [
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "110px"
    },
    {
      value: "name",
      text: "氏名",
      width: "150px"
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "150px"
    },
    {
      value: "payment_method",
      text: "支払方法",
      width: "100px"
    },
    {
      value: "visit_counts",
      text: "訪問回数",
      width: "100px"
    },
    {
      value: "total",
      text: "合計",
      width: "90px"
    },
    {
      value: "medical_insurance",
      text: "医療/国保連",
      width: "120px"
    },
    {
      value: "medical_paymentfund",
      text: "医療/支払基金",
      width: "140px"
    },
    {
      value: "medical_ownexpense",
      text: "医療/自己負担",
      width: "140px"
    },
    {
      value: "adjust_amount1",
      text: "医療/調整",
      width: "120px"
    },
    {
      value: "care_insurance",
      text: "介護/保険",
      width: "120px"
    },
    {
      value: "care_publicexpenditure",
      text: "介護/公費",
      width: "120px"
    },
    {
      value: "care_ownexpense",
      text: "介護/自己負担",
      width: "140px"
    },
    {
      value: "adjust_amount2",
      text: "介護/調整",
      width: "120px"
    },
    {
      value: "ownexpense",
      text: "自費",
      width: "90px"
    },
    {
      value: "date_of_service",
      text: "サービス提供年月",
      width: "150px"
    },
    {
      value: "medical_printed_at",
      text: "医療処理済年月",
      width: "150px"
    },
    {
      value: "care_printed_at",
      text: "介護処理済年月",
      width: "150px"
    },
    {
      value: "user_invoice_printed_at",
      text: "利用者請求処理済年月",
      width: "170px"
    }
  ];

  //=================================================================
  // データテーブルのスタイル用
  //=================================================================
  private isTableScroll = true;

  //=================================================================
  // 対象年月
  //=================================================================
  private get Yearmonth() {
    return this.yearmonth;
  }
  private set Yearmonth(yearmonth: string) {
    this.updateYearmonth(yearmonth);
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    // リサイズイベント登録
    window.onresize = () => {
      this.onresize();
    };
  }

  beforeDestroy() {
    window.onresize = null;
  }

  //---------------------------------------------
  //リサイズイベント
  //---------------------------------------------
  private onresize() {
    // データテーブルのスタイル切り替え
    this.isTableScroll = true;
    const dataTable = document.getElementById(
      "data-table"
    ) as HTMLElement | null;
    if (dataTable) {
      const table = dataTable.children[0].children[0] as HTMLElement | null;
      if (table) {
        if (dataTable.offsetHeight >= table.offsetHeight) {
          // 成り行き
          const root = document.getElementById("root") as HTMLElement | null;
          if (dataTable && root) {
            const dr = dataTable.getBoundingClientRect();
            const rr = root.getBoundingClientRect();
            // console.log('rect', dr, rr)
            if (rr.bottom <= dr.bottom) {
              this.isTableScroll = true;
            } else {
              this.isTableScroll = false;
            }
          }
        } else {
          // スクロール
          this.isTableScroll = true;
        }
      }
    }
  }
}
